import React, { useState, useEffect } from 'react';
import { useCrud } from '../hooks/useCrud';  // Usando o hook useCrud para CRUD
import StorageManager from '../context/StorageManager';
import { Table, Card, Form, Button, Spinner, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import SelecionarCategoria from '../components/Utils/SelecionarCategoria';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { useProvider, Toast } from '../context/MenuProvider';

const ProdutoList = () => {
    const navigate = useNavigate();
    const [avancada, setAvancada] = useState(false); 
    const [isGrade, setIsGrade] = useState(false); 
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [produtos, setProdutos] = useState([]); // Produtos carregados
    const [sincronizar, setSincronizar] = useState(false); // Produtos carregados
    const [filtroEstoque, setFiltroEstoque] = useState('todos'); // Filtro de estoque
    const [filtroCategoria, setFiltroCategoria] = useState([]); // Filtro de estoque
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    const { 
      setLinks, 
      setBtns,
      crud,
      salvarDados,
      hasPerms,
    } = useProvider();

    const { get, patch, loading } = crud ||{};  // Obtendo os métodos do hook useCrud
    
    const handleNovoProduto = () => {
        navigate('/produtos/novo'); // Rota para cadastro de novo produto
    };

    const handleEditarProduto = (id) => {
        navigate(`/produtos/editar/${id}`); // Rota para editar produto com ID específico
    };
    
    const buscarMesclagem = async() => {
      if (!hasPerms("loja.view_convitemesclagemestoque")) return;
      try{
        //const response = await get(`/gvendas/produtos-convite-mesclagem/?ordering=-data`);
        const response = await get(`/gvendas/produtos-convite-mesclagem/?is_ativo=true&ordering=-data`);
        if (response && response.length){
          //alert(JSON.stringify(response))
          const atualizar = response[0].results.some(x => !x.is_sincronizado);
          setSincronizar(atualizar);
        }
      }catch(err){
        
      }finally{
        
      }
    }
    
    // Função para buscar produtos na API
    const buscarProdutos = async (novaBusca = false) => {
        if (!hasPerms("loja.view_produtos")) return;
        let url = `/gvendas/produtos/?ordering=nome_do_produto&filtros=id,foto_do_produto,nome_do_produto,quantidade_em_estoque,preco_unitario,is_sincronizado,is_ativo,is_compartilhar,controlar_estoque,is_catalogo`;

        if (query) url += `&search=${query}`;
        if (filtroEstoque === 'todos') url += `&is_ativo=true`;
        else if (filtroEstoque === 'comEstoque') url += `&is_ativo=true&controlar_estoque=true&quantidade_em_estoque__gt=0`;
        else if (filtroEstoque === 'estoqueBaixo') url += `&is_ativo=true&controlar_estoque=true&is_estoque_baixo=true`;
        else if (filtroEstoque === 'semEstoque') url += `&is_ativo=true&controlar_estoque=true&quantidade_em_estoque=0`;
        else if (filtroEstoque === 'inativo') url += `&is_ativo=false`;
        //if (!filtroCategoria?.length) url += `&categoria__isnull=true`
        if (filtroCategoria?.length) url += `&categoria__in=${filtroCategoria}`;

        if (novaBusca) {
            setProdutos([]); // Limpa os produtos anteriores
            setNextUrl(null); // Reseta o nextUrl
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url,'pagina');
          if(response && response.length){
            const novosProdutos = response[0].results; // Corrigir para acessar o resultado correto
            setProdutos((produtosAnteriores) => novaBusca ? novosProdutos : [...produtosAnteriores, ...novosProdutos]);
            setNextUrl(response[0].next);
            await salvarDados("db_produtos", novosProdutos);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar produtos"
          // });
        }finally{
          
        }
    };

    // Carrega os produtos ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      buscarProdutos(true); // Sempre faz uma nova busca
    }, [query, filtroEstoque, filtroCategoria]);
    
    useEffect(()=>{
      buscarMesclagem();
    },[])
    
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar produtos', to: '/estoque/sincronizar' },
        { name: 'Nova categoria', to: '/categorias/novo/produtos' },
        { name: 'Editar em lote', to: '/produtos/atualizar-quantidade' },
        { name: 'Editar unidades', to: '/produtos/atualizar-quantidade' },
      ]);
      let lista = [
        {icon:'bx-'+(isGrade?'menu':'table'), onClick:() => {setIsGrade(!isGrade);}},
        {icon:'bi-funnel'+(avancada?'-fill':''), onClick:() => {setAvancada(!avancada); setFiltroEstoque('todos');setFiltroCategoria([]);}}
      ];
      if(sincronizar){
        lista = [
          {icon:'bi bi-repeat-1', to:'/produtos/sincronizar'},
          ...lista
        ]
      }
      setBtns(lista);
      return () => {setLinks([]); setBtns([]);}
    }, [sincronizar, setLinks, setBtns, avancada, setAvancada, isGrade]);
    
    
    
    // Detecta o fim da página para carregar mais produtos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutos();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const getIconesList = (item) => {
      let lista = [];
      if(item.is_sincronizado){
        lista=[...lista,'bi-link']
      }
      if(item.is_compartilhar){
        lista=[...lista,'bi-share']
      }
      return lista
    }
    
    const updateProduto = async (item, q) => {
        const listaAtualizada = produtos.map((produto) =>
            produto === item
              ? { ...produto, 
              quantidade_em_estoque: produto.quantidade_em_estoque + q,
              controlar_estoque:true,
              is_ativo:true,
              }
              : produto
        );
        
        const produto = listaAtualizada.find(x => x.id === item.id);
        try{
          const response = await patch({
            quantidade_em_estoque:produto.quantidade_em_estoque,
            controlar_estoque:true,
            is_ativo:true,
          },`/gvendas/produtos/${item.id}/?filtros=id`);
          if(response){
            setProdutos(listaAtualizada);
          }
        }catch(err){
          
        }
        
    };
    const updateProdutoData = async(item, data) =>{
      try{
        await patch(data,`/gvendas/produtos/${item.id}/?filtros=id`, null, 'updateProdutoData');
      }catch(err){

      }
    }
    
    const updateItem = (updatedItem) => {
        setProdutos(produtos.map(item => item.id === updatedItem.id ? updatedItem : item));
    };
    
    const handleInputChange = (index, field, value) => {
      const novaTabela = [...produtos||[]];
  
      if (field === "nome_do_produto") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"nome_do_produto":value});
      }
      if (field === "preco_unitario") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"preco_unitario":parseFloat(value||0).toFixed(2)});
      }
      if (field === "quantidade_em_estoque") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"quantidade_em_estoque":parseInt(value||0)});
      }
      if (field === "controlar_estoque") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"controlar_estoque":value});
      }
      if (field === "is_ativo") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"is_ativo":value});
      }
      if (field === "is_compartilhar") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"is_compartilhar":value});
      }
      if (field === "is_catalogo") {
        novaTabela[index][field] = value;
        updateProdutoData(novaTabela[index], {"is_catalogo":value});
      }
      
      updateItem(novaTabela[index]);
    };

    const listGrade = () =>{
      return (
        <>
                <div className="list-group mt-3">
                    {produtos.length > 0 ? (
                      produtos.map((x) => (
                        <RenderizarProduto
                            key={x.id}
                            icon2={getIconesList(x)}
                            onClick2 = {()=> updateProduto(x, -1)}
                            onClick3 = {()=> updateProduto(x, 1)}
                            //to={`/produtos/${x.id}`}
                            src={x.foto_do_produto}
                            col2="col-auto"//{getItem(x.produto) ?"col-auto":""}
                            titulo3={x.quantidade_em_estoque}
                            //text3="Selecionado"
                            //bcolor={getCor(x.produto)}
                            lm='mb-1'
                            //icon:'bi-box-seam text-muted'
                            text1={x.nome_do_produto}
                            titulo={parseFloat(x.preco_unitario).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            text2={x.controlar_estoque?`${x.quantidade_em_estoque} unidade${x.quantidade_em_estoque>1?'s':''} em estoque`:''}
                        />
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarProdutos(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
        </>
      )
    }
    const listTabela = () =>{
      return (
        <>
          <div className="table-responsive mt-3">
            <Table className="table table-bordered">
              <thead className="table-dark">
                <tr>
                  <th>Nome do produto</th>
                  <th>Preço</th>
                  <th>Quantidade</th>
                  <th>Ativo</th>
                  <th>Controlar</th>
                  <th>Compartilhar</th>
                  <th>Catálogo</th>
                </tr>
              </thead>
              <tbody>
                {produtos.length > 0 ? (
                  produtos.map((x, index) => (
                    <tr>
                      <td>
                        <Form.Control 
                            type="text" 
                            value={x.nome_do_produto} 
                            onChange={(e) => handleInputChange(index, "nome_do_produto", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control 
                            type="number" 
                            value={x.preco_unitario} 
                            onChange={(e) => handleInputChange(index, "preco_unitario", e.target.value)}
                            onBlur={(e) => handleInputChange(index, "preco_unitario", parseFloat(e.target.value||0).toFixed(2))}
                        />
                      </td>
                      <td>
                        <Form.Control 
                            type="number" 
                            value={x.quantidade_em_estoque} 
                            onChange={(e) => handleInputChange(index, "quantidade_em_estoque", e.target.value)}
                            onBlur={(e) => handleInputChange(index, "quantidade_em_estoque", parseInt(e.target.value||0))}
                        />
                      </td>
                      <td>
                        <Form.Check 
                            type="switch" 
                            checked={x.is_ativo} 
                            onChange={(e) => handleInputChange(index, "is_ativo", e.target.checked)}
                        />
                      </td>
                      <td>
                        <Form.Check 
                            type="switch" 
                            checked={x.controlar_estoque} 
                            onChange={(e) => handleInputChange(index, "controlar_estoque", e.target.checked)}
                        />
                      </td>
                      <td>
                        <Form.Check 
                            type="switch" 
                            checked={x.is_compartilhar} 
                            onChange={(e) => handleInputChange(index, "is_compartilhar", e.target.checked)}
                        />
                      </td>
                      <td>
                        <Form.Check 
                            type="switch" 
                            checked={x.is_catalogo} 
                            onChange={(e) => handleInputChange(index, "is_catalogo", e.target.checked)}
                        />
                      </td>
                    </tr>
                  ))
                ):(
                    <tr>
                      <td colspan={6}>
                        {!loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>}
                      </td>
                    </tr>
                )}
              </tbody>
            </Table>
          </div>
        </>
      )
    }
    
    return (
        <>
            <BotaoFlutuante to="/produtos/novo" icon="bi-plus"></BotaoFlutuante>
            <div className="">
                <Form>
                    <Form.Group controlId="formBasicSearch">
                      <div className="input-group">
                        <Form.Control 
                            type="text" 
                            placeholder="Digite o nome do produto" 
                            value={query} 
                            onChange={(e) => setQuery(e.target.value)} 
                        />
                        {!avancada &&(
                            <Button variant="secondary" onClick={() => buscarProdutos(true)}>
                                <i className="bi bi-search"></i>
                            </Button>
                        )}
                      </div>
                    </Form.Group>
                    {avancada && (
                    <>
                      <Form.Group controlId="formSelectStockFilter" className="mt-3">
                        <InputGroup>
                          <span className="input-group-text">Tipo</span>
                          <Form.Control 
                              as="select" 
                              value={filtroEstoque} 
                              onChange={(e) => setFiltroEstoque(e.target.value)}
                          >
                              <option value="todos">Todos</option>
                              <option value="comEstoque">Com Estoque</option>
                              <option value="estoqueBaixo">Estoque Baixo</option>
                              <option value="semEstoque">Sem Estoque</option>
                              <option value="inativo">Inativo</option>
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>
                      
                     <SelecionarCategoria defaultText={` `} multiplos={true} tipo={`produtos`} categoriaId={filtroCategoria} setCategoriaId={setFiltroCategoria} label="Categoria"/>
                     
                      <Button variant="secondary" onClick={() => buscarProdutos(true)} className="mt-2 w-100">
                          Buscar
                      </Button>
                    </>
                    )}
                </Form>
                {isGrade && listGrade()}
                {!isGrade && listTabela()}
            </div>
        </>
    );
};

export default ProdutoList;